<template>
<div class="list-select-wrap flex-row">
  <div class="tip">{{tip}}</div>
  <ul ref="ul_list" :class="[listHeight > 90 && !isShow ? 'slide-up' : '']">
    <a class="li_item" v-for="(item, i) in selectData" :key="i" :class="{active: active === item[id]}" @click="selectActive(item)" href="javascript:void(0);">
      {{item[keyName]}}
    </a>
    <li class="less" @click="lessClick" v-if="isShow">收起 <i class="el-icon-arrow-up"></i></li>
  </ul>
  <span class="more" v-if="listHeight > 90 && !isShow" @click="moreClick">更多 <i class="el-icon-arrow-down"></i></span>
</div>
</template>

<script>
export default {
  props: {
    selectData: {
      type: Array
    },
    tip: {
      type: String
    },
    getItem: {
      type: Function
    },
    keyName: {
      type: String,
      default: "name"
    },
    id: {
      type: String,
      default: "id"
    }
  },
  data() {
    return {
      active: '',
      listHeight: 0,
      isShow: false
    }
  },
  watch: {
    selectData: {
      handler(newVal) {
				newVal ? this.isShow = false : "";
        return newVal;
      },
      deep: true
    },
  },
  methods: {
    selectActive(item) {
      this.active = item[this.id];
      this.getItem && this.getItem(this.active);
    },
    moreClick() {
      this.isShow = true;
    },
    lessClick() {
      this.isShow = false;
    }
  },
  mounted() {
    this.selectData.length > 0 ? this.active = this.selectData[0][this.id] : "";
    this.listHeight = this.$refs.ul_list.getBoundingClientRect().height;
    // console.log(this.listHeight)
  }
}
</script>

<style lang="scss">
.list-select-wrap {
  background: #FAFAFA;
  font-size: 14px;
  box-sizing: border-box;

  &:nth-of-type(1) {
    border-bottom: 1px solid white;
  }

  ul {

    max-height: 1200px;
    width: 80%;
    display: inline-block;
    vertical-align: top;

    min-height: 50px;
    margin-top: 2px;
    padding-left: 30px;

    .li_item {
      display: inline-block;
      margin-right: 30px;
      // padding: 15px 0;
      line-height: 50px;
      cursor: pointer;
      color: #333333;

      &:hover {
        color: #3E97DF;
      }

      &.active {
        color: #3E97DF;
      }
    }

    &.slide-up {
      height: 51px;
      overflow: hidden;
    }

    .less {
      color: #666;
      display: inline-block;
    }
  }

  .tip {
    box-sizing: border-box;
    text-align: center;
    width: 112px;
    display: inline-block;
    vertical-align: top;
    line-height: 52px;
    // margin-right: 30px;
    background: #F2F4F5;
    // border-bottom: 1px solid white;
    color: #666;
  }

  .more {
    display: inline-block;
    line-height: 50px;
    cursor: pointer;
    color: #666;

    &:hover {
      color: #3E97DF;
    }
  }
}
</style>
